import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OfflineResourceCard = ({ resource }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);
    setTimeout(() => {
      setIsDownloading(false);
      setIsDownloaded(true);
    }, 2000);
  };

  const getFileIcon = (type) => {
    switch(type) {
      case 'map': return 'Map';
      case 'guide': return 'BookOpen';
      case 'checklist': return 'ListChecks';
      case 'emergency': return 'AlertCircle';
      default: return 'FileText';
    }
  };

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-5 border border-[var(--color-border)] hover:border-[var(--color-primary)] transition-all hover:shadow-conservation">
      <div className="flex items-start gap-4">
        <div className="p-3 rounded-lg bg-[var(--color-primary)]">
          <Icon name={getFileIcon(resource?.type)} size={24} color="var(--color-primary-foreground)" />
        </div>

        <div className="flex-1">
          <div className="flex items-start justify-between mb-2">
            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-1">{resource?.name}</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300">{resource?.description}</p>
            </div>
            {resource?.essential && (
              <span className="px-2 py-1 bg-[var(--color-accent)] text-[var(--color-accent-foreground)] text-xs font-medium rounded">
                ESSENTIAL
              </span>
            )}
          </div>

          <div className="flex items-center gap-4 mb-3 text-xs text-gray-600 dark:text-gray-300">
            <div className="flex items-center gap-1">
              <Icon name="FileText" size={14} />
              <span>{resource?.format}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="HardDrive" size={14} />
              <span>{resource?.size}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              <span>Updated {resource?.lastUpdated}</span>
            </div>
          </div>

          <div className="flex items-center gap-2">
            {isDownloaded ? (
              <Button variant="success" size="sm" disabled>
                <Icon name="CheckCircle2" size={16} />
                Downloaded
              </Button>
            ) : (
              <Button 
                variant="outline" 
                size="sm" 
                onClick={handleDownload}
                loading={isDownloading}
              >
                <Icon name="Download" size={16} />
                Download
              </Button>
            )}
            <Button variant="ghost" size="sm">
              <Icon name="Eye" size={16} />
              Preview
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineResourceCard;